angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaPolicyDetailsModalsInjectorCtrl', ['$scope', 'ihestiaPolicyDetailsModalsInjectorCfg',
    function($scope, ihestiaPolicyDetailsModalsInjectorCfg) {
      $scope.owuModalSettings = ihestiaPolicyDetailsModalsInjectorCfg.owuModalSettings;
      $scope.policyDocumentsModalSettings = ihestiaPolicyDetailsModalsInjectorCfg.policyDocumentsModalSettings;
      $scope.policyDocumentsModalInfoSettings = ihestiaPolicyDetailsModalsInjectorCfg.policyDocumentsModalInfoSettings;
    }
  ]);
